

import {Link} from 'react-router-dom';
import { Icon, Button as SVAButton, Row, Col, Badge } from 'antd'
import '../../../css/svformwerror.css'
const _ = require('lodash')
const React = require('react')


const HeartSvg = () => (
    <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
      <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z" />
    </svg>
  );


const HeartIcon = props => <Icon component={HeartSvg} {...props} />;

class SVMyResHome extends React.Component {

    constructor(props) {
        super(props)
        let me = this


      
      
    }

    render() {
       
       return (
           
        <div className="svr-det-pageWrapper">
        <header className="svr-header1">
            <h1><span><text style={{color:'#f0d8a9'}}>Welcome, Please Sign In!  </text><Link to={`/svregus/svreguser/-1`}> <Icon  style={{ color: '#eeb838' }} type="profile" theme="filled" /> </Link></span> </h1>
        </header>
             
             
              <div className="col-xs-12" >
                     
                    <div className="l-container">   
                                    <div className="l-box" >
                                        <span className="l-span">
                                                <div className="rev-row ">
                    
                                                        <div className="card card--raised with-shadow">
                                                        
                                                            
                                                    
                                                                <p className="sd-check"><text>New Customer </text></p>
                                                                <p className="sd-content"> <text>  By creating an account on our website, you will be able to shop faster, be up to date on an orders status, and keep track of the orders you have previously made.</text></p>
                                                                
                                                                
                                                                <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/svregus/svreguser/-1`}> Create Account/Profile   </Link></SVAButton>
                                                            

                                                        </div>
                
                                                </div>
                                        </span>
                                    </div>
                                    <div className="l-box">
                                        <span className="l-span"> 

                                        <div className="rev-row ">
                    
                    <div className="card card--raised with-shadow">
                    
                        
                
                            <p className="sd-check"><text>Returning Customer </text></p>
                            <p className="sd-content"> <text>  Already Have account on our website, you will be able to shop faster, be up to date on an orders status, and keep track of the orders you have previously made.</text></p>
                            
                            
                            <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/svlogin`}> Go to Login   </Link></SVAButton>
                        

                    </div>

            </div>
                                             
                                        </span>
                                    </div>
                        
                    </div>
    
             </div>

               
             <div className="col-xs-12" >
        <header className="svr-header-about">
            <h1><span><text style={{color:'#f0d8a9'}}>About Login / Registration  </text><Link to={`/svregus/svreguser/-1`}> <Icon  style={{ color: '#eeb838' }} type="profile" theme="filled" /> </Link></span> </h1>
            
        </header>
        <p className="svr-content-about">For your  convenience we offer the ability to register an account on svabode. Your account gives you access to order history, tracking information for orders you've placed, the ability to save shipping and payment addresses, and the ability to save payment information.</p>
        </div>

        </div>

            )
        
    }

}

export default SVMyResHome